import styles from './contact.module.scss';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import useAnalyticsEventTracker from '../../configs/googleAnalitycs';
import { ContactForm } from '../../components';






const Contact = () => {
	const [t] = useTranslation();

  const googleSheetUrl = "https://script.google.com/macros/s/AKfycbxi7WLfY_tImaPlEIOGOYWEK5CN7xBac22AL-9SQYSmlODIyZ7X-w-5hmG9nxQc-VqRJg/exec"
 
	const gaEventTracker = useAnalyticsEventTracker('Request Demo')

	return (
		<section id="contact" className={styles.container}>
			
			<div className={styles.float_actions}>
				<Link 
				to="contact"
				spy='true'
				onClick={() => gaEventTracker('request')}
				smooth={true}
				offset={50}
				duration={500}
				className={styles.button_link}
				>
					<span >
						{t('section.contact.buttonText')}</span>
				</Link>
			</div>
			
			<div className={styles.content_wrapper}>
				<div className={styles.form_content}>
					<p className={styles.title}>
					{t('section.contact.titleForm').toUpperCase()}
					</p>
					<div style={{width: '100%', backgroundColor:'white', height: 420, display: 'flex', justifyContent:'center', alignItems:'center'}}>
						<ContactForm 
                googleSheetUrl={googleSheetUrl} 
                alertMessageError={t('section.contact.form.errorMessage')} 
                alertMessageSuccess={t('section.contact.form.successMessage')}
              />
					</div>
				</div>
			</div>
		</section>
	);
};



export default Contact;
